import { render, staticRenderFns } from "./assetSelector.html?vue&type=template&id=0baf02f2&scoped=true&"
import script from "./assetSelector.js?vue&type=script&lang=js&"
export * from "./assetSelector.js?vue&type=script&lang=js&"
import style0 from "./assetSelector.scss?vue&type=style&index=0&id=0baf02f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf02f2",
  null
  
)

export default component.exports